module.exports = __webpack_public_path__ + "static/media/youtube-square.4c5eae12.svg";